<template>
    <div>
        <md-cell-item :title="ctData.ct_type" :brief="ctData.account" arrow>
            <iconimg :name="ctData.ct_type" slot="left"></iconimg>
            <div slot="default">
                <div class="upi-text">{{ ctData.pnname }}</div>
                <div class="upi-text">{{ ctData.upi }}</div>
                <div>
                    Status:
                    <pointtext class="ct-status" type="fail" text="Disabled" v-if="get_ct_status() === 'Disabled'"></pointtext>
                    <pointtext class="ct-status" type="success" text="Active" v-if="get_ct_status() === 'Active'"></pointtext>
                    <pointtext class="ct-status" type="notline" text="UnLink" v-if="get_ct_status() === 'UnLink'"></pointtext>
                    <pointtext class="ct-status" type="notline" text="Waiting Kyc" v-if="get_ct_status() === 'Waiting'"></pointtext>
                    <pointtext class="ct-status" type="notline" text="AuthUPI" v-if="get_ct_status() === 'AuthUPI'"></pointtext>
                </div>
                <div class="kyc-remark">
                    Link Stete: 
                    <pointtext class="ct-status" type="success" :text="ctData.state" v-if="ctData.state === 'idle' || ctData.state === 'receiving'"></pointtext>
                    <pointtext class="ct-status" type="notline" :text="ctData.state" v-else></pointtext>

                    <pointtext class="ct-status" type="success" text="In Sell" v-if="ctData.in_sell"></pointtext>
                    <pointtext class="ct-status" type="notline" text="Stop Sell" v-else></pointtext>
                </div>
                <div class="kyc-remark">
                    Remark: {{ get_ctremark(ctData.state_remark) }}
                </div>
            </div>
            <span slot="right" @click="$_showActionSheet">Operating</span>
        </md-cell-item>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import { Popup, PopupTitleBar, ActionSheet, Dialog } from 'mand-mobile'
import { editcollectiontool, getcollectiontool, deletecollectiontool, startsell, stopsell } from '@/request/api'

export default {
    name: 'kycpartneritem',
    props: {
        ct: {
            type: Object,
            default: {}
        }
    },
    components: {
        iconimg,
        pointtext,
        [Popup.name]: Popup,
        [PopupTitleBar.name]: PopupTitleBar,
    },
    data() {
        return {
            ctData: {},
            linkurl: "",
            show: false,
            appendTo: document.body,
            title: 'Enter OTP',
            content: 'OTP has been sent',
            mask: false,
            system: true,
            otpinterval: "",
            otp_send_times: 0,
        }
    },
    created() {
        this.ctData = { ...this.ct };
    },
    watch: {
        ct(newVal) {
            this.ctData = { ...newVal };
        }
    },
    methods: {
        get_ctremark(remark) {
            let outputString = remark;
            if (remark) {
                outputString = remark.replace(/[^\x00-\xff]/g, "?");
            } else {
                outputString = 'NA'
            }
            return outputString;
        },
        refresh_ct() {
            getcollectiontool({ id: this.ctData.id }).then(res => {
                if (res.code === 200) {
                    console.log(res.data);
                    this.ctData = res.data;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            });
        },
        get_ct_status() {
            if (this.ctData.status === 'unavailable') {
                return "Disabled";
            }
            if (this.ctData.status === 'available' && (this.ctData.state === 'receiving' || this.ctData.state === 'idle')) {
                return 'Active';
            }
            if (this.ctData.status === 'available' && (this.ctData.state === 'disabled' || this.ctData.state === 'not_online' || this.ctData.state === 'timeout')) {
                return 'UnLink';
            }
            if (this.ctData.status === 'available' && (this.ctData.state === 'waiting_online')) {
                return 'Waiting';
            }
            if (this.ctData.status === 'available' && (this.ctData.state === 'waiting_authupi')) {
                return 'Auth UPI';
            }
            if (this.ctData.status === 'pause') {
                return 'UnLink';
            }
            if (this.ctData.status == 'waitauth') {
                return 'AuthUPI';
            }
        },
        get_operate_options(){
            let ct_status = this.get_ct_status();
            let options = [
                {
                    label: 'Link Kyc Partner',
                    value: 'link',
                },
                {
                    label: 'Disconnect',
                    value: 'disconnect',
                },
                {
                    label: 'Edit',
                    value: 'edit',
                },
                {
                    label: 'Delete',
                    value: 'delete'
                },
            ];
            if(ct_status === 'Disabled') {
                options = [
                    {
                        label: 'Edit',
                        value: 'edit'
                    },
                    {
                        label: 'Delete',
                        value: 'delete'
                    },
                ];
            }

            if(ct_status === 'UnLink') {
                options = [
                    {
                        label: 'Link Kyc Partner',
                        value: 'link',
                    }
                ];
            }

            if(ct_status === 'Active') {
                options = [
                    {
                        label: 'Disconnect',
                        value: 'disconnect'
                    },
                    {
                        label: 'Edit',
                        value: 'edit'
                    }
                ];
            }
            if(ct_status === 'Waiting') {
                options = [
                    {
                        label: 'Waiting Kyc',
                        value: 'waiting_kyc'
                    }
                ];
            }
            if(ct_status === 'AuthUPI') {
                options = [
                    {
                        label: 'Auth UPI',
                        value: 'auth_upi'
                    },
                    {
                        label: 'Edit',
                        value: 'edit',
                    }
                ]
            }
            if(!this.ctData.in_sell) {
                options.push({
                    label: 'Start Sell',
                    value: 'start_sell',
                })
            } else {
                options.push({
                    label: 'Stop Sell',
                    value: 'stop_sell',
                })
            }
            return options
        },
        $_showActionSheet() {
            let options = this.get_operate_options();
            ActionSheet.create({
                value: true,
                title: 'Operate the linked Kyc Partner',
                options: options,
                defaultIndex: 0,
                cancelText: 'Cancel',
                onCancel: this.$_cancel,
                onSelected: this.$_selected,
            })
        },
        $_selected(item) {
            if(item.value === 'link') {
                this.link();
            } else if (item.value === 'disconnect') {
                this.disconnect()
            } else if (item.value === 'edit') {
                this.$router.push('/editkycpartner/edit/' + this.ctData.id)
            } else if (item.value === 'delete') {
                deletecollectiontool({id: this.ctData.id}).then(res=>{
                    if(res.code === 200) {
                        this.$toast.succeed('delete successfully');
                        this.$emit('refreshkyclist');
                    } else {
                        this.$toast.failed(res.errmsg);
                        this.refresh_ct();
                    }
                })
            } else if (item.value === 'auth_upi') {
                this.show_auth();
            } else if (item.value === 'waiting_kyc') {
                this.disconnect()
                
                this.show_auth();
            } else if (item.value === 'start_sell') {
                startsell({ct_id: this.ctData.id}).then(res=>{
                    if(res.code === 200) {
                        this.$toast.succeed("start sell successfully");
                        this.refresh_ct();
                    } else {
                        this.$toast.failed(res.errmsg);
                    }
                })
            } else if (item.value === 'stop_sell') {
                stopsell({ct_id: this.ctData.id}).then(res=>{
                    if(res.code === 200) {
                        this.$toast.succeed("stop sell successfully");
                        this.refresh_ct();
                    } else {
                        this.$toast.failed(res.errmsg);
                    }
                })
            }
        },
        $_cancel() {
            console.log('action-sheet cancel')
        },
        link() {
            let ct = this.ctData;
            this.$toast.loading("waiting for link");
            editcollectiontool({
                id: ct.id,
                status: 'available'
            }).then(res=>{
                if(res.code === 200) {
                    let that = this;
                    setTimeout(() => {
                        that.$toast.hide();
                        that.$toast.succeed("link successful");
                        that.refresh_ct();
                    }, 1500);
                } else {
                    // 跳转 编辑 页面
                    this.$router.push('/editkycpartner/link/' + this.ctData.id);
                }
            })
        },
        disconnect() {
            Dialog.confirm({
                title: 'Confirm',
                content: 'Confirm whether to unlink',
                confirmText: 'Confirm',
                cancelText: 'Cancel',
                onConfirm: () => {
                    editcollectiontool({
                        id: this.ctData.id,
                        status: "pause"
                    }).then(res=>{
                        if(res.code === 200) {
                            this.$toast.succeed("Successfully unlinked");
                            this.refresh_ct();
                        } else {
                            this.$toast.failed(res.errmsg);
                            this.refresh_ct();
                        }
                    })
                },
            })
        }
    },
}

</script>

<style scoped>
.upi-text {
    max-width: 4rem;
}
.kyc-remark {
    color: #858b9c;
    font-size: 0.27rem;
}
.ct-status {
    display: inline;
}
</style>



// WEBPACK FOOTER //
// src/views/my/kycpartneritem.vue